import * as actions from './ReviewTabReducer';

export function update(value) {
  return (dispatch) => {
    dispatch({
      type: actions.UPDATE,
      updateBolton: value,
    });
  };
}

export function isGoldUpdated(value) {
  return (dispatch) => {
    dispatch({
      type: actions.ISGOLD,
      isGoldUpdated: value,
    });
  };
}

export function goToReview(value) {
  return (dispatch) => {
    dispatch({
      type: actions.GOTOREVIEW,
      goToReview: value,
    });
  };
}
